import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pushEvent } from '../utils/gtm';
import { getAttribution, captureLandingPath } from '../utils/attribution';
import { initMetaClickIds } from '../utils/getMetaClickIds';
import { persistVoluumClickIdFromSearch } from '../utils/voluumClickId';
import { SS_LEAD_LANDING_VIEW_SENT } from '../configs/storageKeys';
import { GA4_EVENTS } from '../constants/ga4Events';
import { PENDING, OFFERS, FINAL, INFO, COOKIES, AUTO_REGISTER, UNSUBSCRIBE, DEV_FINAL_VALIDATION_FLOW, DEV_FINAL_THANKYOU_FLOW, DEV_PENDING_FLOW } from '../constants/constantApi';
import { getFormLink } from '../utils/getTld';

const NON_LANDING_SEGMENTS = new Set([PENDING, OFFERS, FINAL, INFO, COOKIES, AUTO_REGISTER, UNSUBSCRIBE]);
// Полные пути dev-роутов: исключаем их, но не блокируем landing-слаг /dev (route /:seoPageHtml).
const NON_LANDING_PATHS = new Set([DEV_FINAL_VALIDATION_FLOW, DEV_FINAL_THANKYOU_FLOW, DEV_PENDING_FLOW]);

/** Fires lead_landing_view once per pathname per session. Must render inside BrowserRouter. */
export function LandingViewTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Capture the session entry point once, before any landing-specific early returns.
    captureLandingPath(pathname);
    // Meta: сохранить fbclid и актуализировать _fbc на первом заходе (step2 может быть без fbclid).
    initMetaClickIds();
    persistVoluumClickIdFromSearch();

    const normalized = pathname.replace(/^\//, '').replace(/\/$/, '');
    const segment = normalized.split('/')[0];
    if (NON_LANDING_SEGMENTS.has(segment) || segment === getFormLink()) return;
    if (NON_LANDING_PATHS.has(normalized)) return;

    const key = `${SS_LEAD_LANDING_VIEW_SENT}:${pathname}`;
    let alreadySent = false;
    try { alreadySent = !!sessionStorage.getItem(key); } catch {}
    if (alreadySent) return;

    const sent = pushEvent(GA4_EVENTS.LEAD_LANDING_VIEW, getAttribution());
    if (sent) {
      try { sessionStorage.setItem(key, '1'); } catch {}
    }
  }, [pathname]);

  return null;
}
